const PRESENCE_SESSION_STORAGE_KEY = 'messenger-v2.presence-session-id';

const createPresenceSessionId = () => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {}

  return `presence-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getMessengerV2PresenceSessionId = () => {
  if (typeof window === 'undefined') return null;

  try {
    const existing = window.sessionStorage.getItem(PRESENCE_SESSION_STORAGE_KEY);
    if (existing) return existing;

    const next = createPresenceSessionId();
    window.sessionStorage.setItem(PRESENCE_SESSION_STORAGE_KEY, next);
    return next;
  } catch {
    return createPresenceSessionId();
  }
};

